import axios from '@/api/axios'

const createNews = (news) => {
  return axios.post('/news-posts', news)
}

const getNewsAll = (params) => {
  return axios.get('/news-posts', {params})
}

const getNews = (id) => {
  return axios.get(`/news-posts/${id}`)
}

const updateNews = (id, newInput) => {
  return axios.put(`/news-posts/${id}`, newInput)
}

const deleteNews = (id) => {
  return axios.delete(`/news-posts/${id}`)
}

export default {
  createNews,
  getNewsAll,
  getNews,
  updateNews,
  deleteNews,
}
